import { axiosInstance } from '../axiosInstance';
import { returnErrors, clearErrors } from '../actions/errorActions';
import {
    GET_SOCIALS_LOADING,
    GET_SOCIALS_SUCCESS,
    GET_SOCIALS_FAIL
} from "./types";

export const getSocial = () => {
    return async function(dispatch){
        //Headers

        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        dispatch(clearErrors());
        dispatch({
            type: GET_SOCIALS_LOADING
        });
        try {
            let response = await axiosInstance.get(
                '/api/socials',
                config
            );
            if(response.status !== 200){
                dispatch({
                    type: GET_SOCIALS_FAIL,
                });
                throw Error({
                    response: {
                        data: "Other Errors",
                        status: "Other Errors"
                    },
                })
            }else{
                dispatch({
                    type: GET_SOCIALS_SUCCESS,
                    payload: response.data
                })
            }
        } catch (error) {
            if (error.response && error.response.data) {
                dispatch(returnErrors(error.response.data, error.response.status, 'GET_SOCIALS_FAIL'));
                dispatch ({ 
                    type: GET_SOCIALS_FAIL 
                });
            }else{
                let errorJson = JSON.stringify(error);
                let errorParsed = JSON.parse(errorJson);
                return (
                    dispatch(returnErrors(errorParsed.message, "Network Error", 'GET_SOCIALS_FAIL')),
                    dispatch ({ 
                        type: GET_SOCIALS_FAIL 
                    })
                )
            }
        }
    }
};